import gql from "graphql-tag";

export const SUBSCRIPTION_SURVEYS_QUERY = gql`
  query subscriptionSurveys(
    $submittedDate_Lte: Date
    $submittedDate_Gte: Date
    $isSubmitted: Boolean
    $orderBy: String
    $surveyType: String
    $endTypes: [String]
    $endTransitionProductTypes: [String]
    $corporateTypes: Boolean
  ) {
    subscriptionSurveys(
      submittedDate_Lte: $submittedDate_Lte
      submittedDate_Gte: $submittedDate_Gte
      isSubmitted: $isSubmitted
      orderBy: $orderBy
      survey_SurveyType: $surveyType
      subscription_EndType_In: $endTypes
      subscription_EndTransitionProductType_In: $endTransitionProductTypes
      subscription_CorporateChallengeId_Isnull: $corporateTypes
    ) {
      edges {
        node {
          id
          submittedDate
          survey {
            id
            title
            surveyType
          }
          answerSet {
            id
            surveyQuestion {
              id
              question {
                id
                title
                questionType
              }
            }
            option {
              id
              title
            }
            answer
          }
          subscription {
            id
            endType
            endTransitionProductType
            endDate
            transitionProductVariant {
              id
              product {
                id
                title
              }
            }
            coach {
              id
              firstName
              lastName
            }
            user {
              id
              firstName
              lastName
              email
            }
            product {
              id
              type
            }
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTION_SURVEY_QUERY = gql`
  query subscriptionSurvey($subscriptionSurveyId: ID!) {
    subscriptionSurvey(subscriptionSurveyId: $subscriptionSurveyId) {
      id
      submittedDate
      title
      survey {
        id
        title
        surveyType
      }
      subscription {
        id
        endDate
        transitionProductVariant {
          id
          product {
            id
            title
          }
        }
        coach {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
          email
        }
        product {
          id
          type
        }
      }
      answerSet {
        id
        surveyQuestion {
          id
          question {
            id
            title
          }
        }
        option {
          id
          title
        }
        answer
      }
    }
  }
`;

export const SUBSCRIPTION_SURVEYS_EXPORT_QUERY = gql`
  query surveyExport($startDate: Date!, $endDate: Date!, $surveyType: String!) {
    surveyExport(startDate: $startDate, endDate: $endDate, surveyType: $surveyType)
  }
`;
